import React from "react";

// reactstrap components
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	Row,
	Col,
	FormGroup,
	Label,
	Input
} from "reactstrap";
import { getUserRequest, createUserRequest, updateUserRequest } from "api/user";
import { getFormattedDate } from "helpers/date";
import { getRoles } from "helpers/auth";

class UserForm extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			user: null,
			error: null
		}
	}

	async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

		if (id) {
			try {
				const user = await getUserRequest(id);
				this.setState({ user })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching user'
				});
			}
		} else {
			// case for adding a user
			this.setState({
				user: {
					name: '',
				}
			})
		}
	}

	goTo = path => this.props.history.push(path);

	onChangeField = (e) => {
		const { target } = e;
		const { name, value } = target;
		this.setState(prevState => ({
			user: {
				...prevState.user,
				[name]: value,
			},
		}));
	}

	save = async () => {
		const { user } = this.state;
		const { _id } = user;
		
		try {
			if (_id) {
				await updateUserRequest(user);
			} else {
				await createUserRequest(user);
			}
			this.goTo('/users');
		} catch (err) {
			console.log(err, "error");
			this.setState({
				error: err.message || 'There was an error saving user'
			})
		}
	}

	onChangeAddress = (event) => {
		const { name, value } = event.target;
		this.setState((prevState) => ({
			user: {
				...prevState.user,
				address: {
					...(prevState.user.address || {}),
					[name]: value
				}
			}
		}));
	}

	render() {

		const {
			user = {},
			error = null
		} = this.state;

		const {
			_id,
			first_name,
			last_name,
			email,
			password,
			phone,
			role,
			created_at,
			updated_at
		} = user || {};

		return (
			<>
				<div className="content">
					<Row>
						<Col md="12">
							<Card>
								<CardHeader className="mb-5">
									<CardTitle tag="h3">
										{_id
											? "Edit User"
											: "Create User"
										}
                  					</CardTitle>
									<Button
										className="float-right"
										color="default"
										onClick={() => this.goTo('/users')}
									>
										Back
                  					</Button>
								</CardHeader>
								<CardBody>
									{!user
										? <div>Carregando...</div>
										: <>
											<FormGroup>
												<Label>First Name <span className="required-start">*</span></Label>
												<Input
													type="text"
													name="first_name"
													value={first_name || ''}
													onChange={this.onChangeField}
												/>
											</FormGroup>
											<FormGroup>
												<Label>Last Name <span className="required-start">*</span></Label>
												<Input
													type="text"
													name="last_name"
													value={last_name || ''}
													onChange={this.onChangeField}
												/>
											</FormGroup>
											<FormGroup>
												<Label>Email <span className="required-start">*</span></Label>
												<Input
													type="text"
													name="email"
													value={email || ''}
													onChange={this.onChangeField}
												/>
											</FormGroup>
											{!_id ? <FormGroup>
												<Label>Password <span className="required-start">*</span></Label>
												<Input
													type="text"
													name="password"
													value={password || ''}
													onChange={this.onChangeField}
												/>
											</FormGroup> : null}
											<FormGroup>
												<Label>Phone</Label>
												<Input
													type="text"
													name="phone"
													value={phone || ''}
													onChange={this.onChangeField}
												/>
											</FormGroup>
											<FormGroup>
												<Label>Role <span className="required-start">*</span></Label>
												<Input
													type="select"
													name="role"
													value={role || ''}
													onChange={this.onChangeField}
												>
													<option value="">--SELECT--</option>
													{getRoles().map(role => {
														return <option key={role} value={role}>{role}</option>
													})}
												</Input>
											</FormGroup>
											{_id ? <><FormGroup>
												<Label>Created At</Label>
												<Input
													type="text"
													name="created_at"
													value={getFormattedDate(created_at || '')}
													readOnly
												/>
											</FormGroup>
												<FormGroup>
													<Label>Updated At</Label>
													<Input
														type="text"
														name="updated_at"
														value={getFormattedDate(updated_at || '')}
														readOnly
													/>
												</FormGroup>
											</> : null}
										</>
									}
									{error ? <div className="alert alert-danger mt-3">
											<span>{error}</span>
										</div> : null
									}
								</CardBody>
								{user ? <Col>
									<Button color="primary" block={false} className="mb-4" onClick={this.save}>
										{_id
											? "Save Changes"
											: "Save User"
										}
									</Button>
								</Col> : null}
							</Card>
						</Col>
					</Row>
				</div>
			</>
		);
	}
}

export default UserForm;
